<div class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="TitleLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">

            <!-- Modal Header - OEE Style -->
            <div class="modal-header">
                <div class="header-icon">
                    <i class="fas fa-folder-open"></i>
                </div>
                <h2 class="modal-title" id="TitleLabel">{{ title }}</h2>
                <button type="button" class="btn-close" aria-label="Close" (click)="_cancel()"></button>
            </div>

            <!-- Modal Body -->
            @if (selectedProject$ | async; as project) {
                <div class="modal-body">
                    <!-- Top Section: Two-column layout -->
                    <div class="d-flex mb-3">
                        <!-- Left Column: Thumbnail -->
                        <div class="thumbnail-container">
                            <img [src]="project.thumbnail || kartoriumLogo" alt="Project Thumbnail">
                            <!-- Edit Button (for non-Viewers) -->
                            @if (currentUserPermission != 'Viewer') {
                                <label class="edit-btn"
                                    for="project-thumbnail-input" tabindex="0" role="button"
                                    (keydown.enter)="thumbnailInput.click()" (keydown.space)="thumbnailInput.click()">
                                    <i class="fas fa-edit"></i>
                                </label>
                            }
                            <!-- Clear Button (shows only if a thumbnail exists) -->
                            @if (currentUserPermission != 'Viewer' && project.thumbnail) {
                                <button type="button"
                                    class="clear-btn" (click)="clearThumbnail()">
                                    <i class="fas fa-times"></i>
                                </button>
                            }
                            <input #thumbnailInput id="project-thumbnail-input" type="file" accept="image/*"
                                (change)="addThumbnail($event.target.files[0])" hidden>
                        </div>

                        <!-- Right Column: Title, Description, Timestamps -->
                        <div class="ms-3 flex-grow-1">
                            <!-- Title -->
                            @if (currentUserPermission != 'Viewer') {
                                <div>
                                    <div class="form-floating mb-2">
                                        <input type="text" class="form-control" id="floatingTitle" [(ngModel)]="project.title"
                                            (blur)="updateProject(project)" placeholder="Project Title">
                                        <label for="floatingTitle">Project Title</label>
                                    </div>
                                </div>
                            } @else {
                                <h3 class="view-title">{{ project.title }}</h3>
                            }

                            <!-- Description -->
                            @if (currentUserPermission != 'Viewer') {
                                <div>
                                    <div class="form-floating mb-2">
                                        <textarea class="form-control" id="floatingDescription" style="height: 100px;"
                                            [(ngModel)]="project.description" (blur)="updateProject(project)"
                                            placeholder="Project description"></textarea>
                                        <label for="floatingDescription">Project Description</label>
                                    </div>
                                </div>
                            } @else {
                                <p class="view-description">{{ project.description }}</p>
                            }

                            <!-- Timestamps -->
                            <div class="timestamp-row">
                                <span class="timestamp-label">Created:</span> {{ project.createdOn | date:'medium' }}
                            </div>
                            <div class="timestamp-row">
                                <span class="timestamp-label">Last edited:</span> {{ project.lastEdited | date:'medium' }}
                            </div>
                        </div>
                    </div>

                    <!-- Editor-Only Additional Controls -->
                    @if (currentUserPermission != 'Viewer') {
                        <!-- Project Settings -->
                        <fieldset class="project-settings">
                            <legend class="section-header">Project Settings</legend>
                            <div class="form-check form-switch mb-2">
                                <input id="public-switch" type="checkbox" class="form-check-input"
                                    [(ngModel)]="project.publicStatus" (change)="updateProject(project)"
                                    [disabled]="inFreeTier">
                                <label class="form-check-label" for="public-switch">
                                    @if (inFreeTier) {
                                        <i class="fas fa-lock"></i>
                                    } Public Project
                                </label>
                                @if (inFreeTier) {
                                    <div class="toggle-helper">
                                        Private projects are disabled in free tier.
                                    </div>
                                }
                                @if (!inFreeTier) {
                                    <div class="toggle-helper">
                                        Make project visible to everyone.
                                    </div>
                                }
                            </div>
                            @if (hasOrganization) {
                                <div class="form-check form-switch mb-2">
                                    <input id="share-org" type="checkbox" class="form-check-input"
                                        [(ngModel)]="project.sharedWithOrganization" (change)="updateProject(project)"
                                        [disabled]="inFreeTier">
                                    <label class="form-check-label" for="share-org">
                                        @if (inFreeTier) {
                                            <i class="fas fa-lock"></i>
                                        } Share with Organization
                                    </label>
                                    @if (inFreeTier) {
                                        <div class="toggle-helper">
                                            Organization sharing is disabled in free tier.
                                        </div>
                                    }
                                    @if (!inFreeTier) {
                                        <div class="toggle-helper">
                                            Make project visible to your Organization.
                                        </div>
                                    }
                                </div>
                            }
                        </fieldset>
                    }

                    <!-- Collaborators Section -->
                    @if (hasOrganization) {
                        <div class="mt-3">
                            @if (currentUserPermission == 'Owner') {
                                <h4 class="section-header">Manage Collaborators</h4>
                            }
                            @if (currentUserPermission != 'Owner') {
                                <h4 class="section-header">Collaborators</h4>
                            }
                            <div class="permissions-wrapper">
                                <shared-edit-project-permissions></shared-edit-project-permissions>
                            </div>
                        </div>
                    }
                </div>
            }

            <div class="modal-footer d-flex align-items-center">
                @if (currentUserPermission == 'Owner') {
                    <div>
                        <button type="button" class="btn-delete-project" (click)="deleteProject()">
                            <i class="fas fa-trash-alt"></i> Delete
                        </button>
                    </div>
                }
                <div class="ms-auto">
                    <button type="button" class="btn-close-modal" (click)="_cancel()">{{ cancelText }}</button>
                </div>
            </div>
        </div>
    </div>
</div>
